module.exports = __webpack_public_path__ + "img/tebyeen.4153ffec.png";